import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';
import { isNativeIntegration } from 'src/core/modules/bookkeep/integration/status';

import { useAccountingSoftwareName } from '../apis';

export const useHasMapSync = (): boolean => {
  const isEnabled = useFeature(FEATURES.TMP_MAP_SYNC);
  const { integration } = useAccountingSoftwareName();

  if (!integration) {
    return false;
  }

  return isEnabled && isNativeIntegration(integration);
};
